import {
  EncounterAbilitySegment,
  EncounterAbilitySegmentType,
} from 'app/frontend/types/custom/EncounterEvents'

export type ResolvedTimelineSegment = {
  type: EncounterAbilitySegmentType
  start: number
  end: number
  duration: number
  tooltip?: string | null
  color?: string | null
}

export const resolveEntrySegments = ({
  time,
  duration,
  segments,
}: {
  time: number
  duration: number
  segments?: EncounterAbilitySegment[] | null
}): ResolvedTimelineSegment[] => {
  const entryEnd = time + duration
  if (duration <= 0) return []

  const source =
    segments && segments.length > 0
      ? segments
      : [{ type: 'SOLID' as const, duration }]

  const resolved: ResolvedTimelineSegment[] = []
  let cursor = time

  source.forEach((segment) => {
    if (cursor >= entryEnd) return

    const start = cursor
    const end = Math.min(start + Math.max(segment.duration, 0), entryEnd)
    cursor = end
    if (end <= start) return

    resolved.push({
      type: segment.type,
      start,
      end,
      duration: end - start,
      tooltip: segment.tooltip,
      color: segment.color,
    })
  })

  return resolved
}
